import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/7_3.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Rzeka"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p19,
            }}
            content={
                <div>
                    <ul>
                        <li>
                            Co to za rzekę widać ze wzgórza?
                        </li>
                        <li>
                            Warta. Nawet tutaj widać, o… Chodź no, zobacz, widzisz? To końskie doły, kiedyś ona tędy płynęła. A dziś tam ryby łowią, ot natura rzeczy! Rzeka często wylewa i trzeba dbać o łąki dookoła. Kiedyś odzyskiwaliśmy łąki zalewowe pod zboże, Holendrzy to robili, tak zwani, bo to wolni chłopi stamtąd byli, a wiadomo, ile ziemi wodzie wyrwali w Niderlandach! Jeszcze inni strzygą łąki wokół rzeki, żeby woda była czystsza, jak zaleje, bo tyle się tam paskudztwa zbiera… I gęsi tam wypasają, bo z tego Zagórów słynie, wiesz? A ile robią ambarasu dla pasterzy krów! Brudzą strasznie, ale co poradzisz. Z takiej gęsi to i pierze na pierzynę się wyskubie, i na stół świąteczny pieczeń upitrasi. A i smalec się zrobi!
                        </li>
                    </ul>
                </div>
            }
        />

    );
}